import "@browsemate/design-tokens/tokens.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { HostedAccount } from "./HostedAccount";
import { LegacyAccountShell } from "./legacy-account";
import "./styles.css";

// Keep the historical direct-provider callback separate during rollout.
const legacyCallback = location.pathname === "/auth/wechat/callback";
const root = document.querySelector<HTMLDivElement>("#root");
if (!root) throw new Error("Missing application root");
createRoot(root).render(
  <React.StrictMode>
    {legacyCallback ? <LegacyAccountShell /> : <HostedAccount />}
  </React.StrictMode>,
);
